<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<form #f="ngForm" novalidate>
  <div class="row m-0 formborder">
    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Name </span>
      <input
        required
        type="text"
        #refCompanyName="ngModel"
        maxlength="250"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyName.invalid,
          'alert-warning':
            refCompanyName.invalid &&
            (refCompanyName.dirty ||
              refCompanyName.touched ||
              refCompanyName.untouched)
        }"
        [(ngModel)]="CompanyName"
        placeholder="Enter Company Name"
        name="CompanyName"
        id="CompanyName"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable">Default CRC Agency </span>
      <select
        name="Agency"
        id="Agency"
        #refAgency="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refAgency.invalid,
          'alert-warning':
            refAgency.invalid &&
            (refAgency.dirty || refAgency.touched || refAgency.untouched)
        }"
        [(ngModel)]="CRC_Agency"
        class="form-control input-text-css"
        required
      >
        <option value="">Select Agency</option>
        <option *ngFor="let Type of CRC_Agency_Bind" [value]="Type.Id">
          {{ Type.Value }}
        </option>
      </select>
    </div>
    <!-- <div class="col-md-2 p-1" style="text-align: center">
      <button (click)="Add_Current_FinancialYear()"
              class="btn font-size-12 button-btn">
        Add Current Financial Year
      </button>

    </div> -->
    <div class="col-md-6 p-1">
      <span class="required-lable"> Company Head Office Address </span>
      <input
        required
        type="text"
        #refCompanyHOAddress="ngModel"
        maxlength="150"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyHOAddress.invalid,
          'alert-warning':
            refCompanyHOAddress.invalid &&
            (refCompanyHOAddress.dirty ||
              refCompanyHOAddress.touched ||
              refCompanyHOAddress.untouched)
        }"
        [(ngModel)]="CompanyHOAddress"
        placeholder="Enter Company HO Address"
        name="CompanyHOAddress"
        id="CompanyHOAddress"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Corporate Office Address </span>
      <input
        type="text"
        #refcompanyCorporateAddress="ngModel"
        maxlength="150"
        [(ngModel)]="companyCorporateAddress"
        placeholder="Enter Company Corporate Address"
        name="companyCorporateaddress"
        id="companyCorporateaddress"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span> State Code </span>
      <select
        name="FilterStateId"
        id="FilterStateId"
        [(ngModel)]="FilterStateId"
        class="form-control input-text-css"
      >
        <option value="">Select State</option>
        <option
          *ngFor="let StateList of FilterStateList"
          [value]="StateList.Code"
        >
          {{ StateList.State_Name }}
        </option>
      </select>
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Date of incorporation </span>
      <div class="datepicker_feild">
        <input
          required
          [matDatepicker]="picker"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="CompanyDateofIncorporation"
          id="CompanyDateofIncorporation"
          #refCompanyIncorporationDate="ngModel"
          [ngClass]="{
            'is-invalid': f.submitted && refCompanyIncorporationDate.invalid,
            'alert-warning':
              refCompanyIncorporationDate.invalid &&
              (refCompanyIncorporationDate.dirty ||
                refCompanyIncorporationDate.touched ||
                refCompanyIncorporationDate.untouched)
          }"
          [(ngModel)]="CompanyDateofIncorporation"
          class="form-control input-text-css"
          [(ngModel)]="CompanyDateofIncorporation"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Reg. No </span>
      <input
        required
        type="text"
        #refCompanyRegNo="ngModel"
        maxlength="50"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyRegNo.invalid,
          'alert-warning':
            refCompanyRegNo.invalid &&
            (refCompanyRegNo.dirty ||
              refCompanyRegNo.touched ||
              refCompanyRegNo.untouched)
        }"
        [(ngModel)]="CompanyRegNoName"
        placeholder="Enter Company Reg No"
        name="CompanyRegNo"
        id="CompanyRegNo"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Company GST. No </span>
      <input
        required
        type="text"
        #refCompanyGSTNo="ngModel"
        maxlength="50"
        maxlength="50"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyGSTNo.invalid,
          'alert-warning':
            refCompanyGSTNo.invalid &&
            (refCompanyGSTNo.dirty ||
              refCompanyGSTNo.touched ||
              refCompanyGSTNo.untouched)
        }"
        [(ngModel)]="CompanyGSTNo"
        placeholder="Enter Company GST No"
        name="CompanyGSTNo"
        id="CompanyGSTNo"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Company TAN No </span>
      <input
        required
        type="text"
        #refCompanyTANNo="ngModel"
        maxlength="50"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyTANNo.invalid,
          'alert-warning':
            refCompanyTANNo.invalid &&
            (refCompanyTANNo.dirty ||
              refCompanyTANNo.touched ||
              refCompanyTANNo.untouched)
        }"
        [(ngModel)]="CompanyTANNo"
        placeholder="Enter Company TAN No"
        name="CompanyTANNo"
        id="CompanyTANNo"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Company PAN No </span>
      <input
        required
        type="text"
        #refCompanyPANNo="ngModel"
        maxlength="10"
        minlength="10"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyPANNo.invalid,
          'alert-warning':
            refCompanyPANNo.invalid &&
            (refCompanyPANNo.dirty ||
              refCompanyPANNo.touched ||
              refCompanyPANNo.untouched)
        }"
        [(ngModel)]="CompanyPANNo"
        placeholder="Enter Company PAN No"
        name="CompanyPANNo"
        id="CompanyPANNo"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Phone No </span>
      <input
        required
        type="text"
        numbersOnly
        maxlength="10"
        minlength="10"
        #refCompanyPhoneNo="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyPhoneNo.invalid,
          'alert-warning':
            refCompanyPhoneNo.invalid &&
            (refCompanyPhoneNo.dirty ||
              refCompanyPhoneNo.touched ||
              refCompanyPhoneNo.untouched)
        }"
        [(ngModel)]="CompanyPhoneNo"
        placeholder="Enter Company Phone No"
        name="CompanyPhoneNo"
        id="CompanyPhoneNo"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Company Phone No 1</span>
      <input
        required
        type="text"
        numbersOnly
        maxlength="10"
        minlength="10"
        #refCompanyPhoneNo1="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refCompanyPhoneNo1.invalid,
          'alert-warning':
            refCompanyPhoneNo1.invalid &&
            (refCompanyPhoneNo1.dirty ||
              refCompanyPhoneNo1.touched ||
              refCompanyPhoneNo1.untouched)
        }"
        [(ngModel)]="CompanyPhoneNo1"
        placeholder="Enter Company Phone No 1"
        name="CompanyPhoneNo1"
        id="CompanyPhoneNo1"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span> Company WhatsApp No </span>
      <input
        required
        type="text"
        #refCompanyWhatAppNo="ngModel"
        maxlength="50"
        [(ngModel)]="CompanyWhatAppNo"
        placeholder="Enter Company WhatsApp No"
        name="CompanyWhatAppNo"
        id="CompanyWhatAppNo"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span> Company Email</span>
      <input
        required
        type="text"
        #refCompanyPhoneNo1="ngModel"
        maxlength="50"
        [(ngModel)]="ComapnyEmail"
        placeholder="Enter Company Email"
        name="ComapnyEmail"
        id="ComapnyEmail"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Rejected Application Reopen Days </span>
      <input
        required
        type="number"
        #refReopenDays="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refReopenDays.invalid,
          'alert-warning':
            refReopenDays.invalid &&
            (refReopenDays.dirty ||
              refReopenDays.touched ||
              refReopenDays.untouched)
        }"
        [(ngModel)]="ReopenDays"
        placeholder="Enter Rejected Application Reopen Days"
        name="ReopenDays"
        id="ReopenDays"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable">Application No Prefix </span>
      <input
        required
        type="text"
        #refApplicationNoPrefix="ngModel"
        maxlength="2"
        [ngClass]="{
          'is-invalid': f.submitted && refApplicationNoPrefix.invalid,
          'alert-warning':
            refApplicationNoPrefix.invalid &&
            (refApplicationNoPrefix.dirty ||
              refApplicationNoPrefix.touched ||
              refApplicationNoPrefix.untouched)
        }"
        [(ngModel)]="ApplicationNoPrefix"
        placeholder="Enter Application No Prefix"
        name="ApplicationNoPrefix"
        id="ApplicationNoPrefix"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Branch Code Prefix </span>
      <input
        required
        type="text"
        #refBranchCodePrefix="ngModel"
        maxlength="2"
        [ngClass]="{
          'is-invalid': f.submitted && refBranchCodePrefix.invalid,
          'alert-warning':
            refBranchCodePrefix.invalid &&
            (refBranchCodePrefix.dirty ||
              refBranchCodePrefix.touched ||
              refBranchCodePrefix.untouched)
        }"
        [(ngModel)]="BranchCodePrefix"
        placeholder="Enter Branch Code Prefix"
        name="BranchCodePrefix"
        id="BranchCodePrefix"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Enquiry No Prefix </span>
      <input
        required
        type="text"
        #refEnquiryNoPrefix="ngModel"
        maxlength="2"
        [ngClass]="{
          'is-invalid': f.submitted && refEnquiryNoPrefix.invalid,
          'alert-warning':
            refEnquiryNoPrefix.invalid &&
            (refEnquiryNoPrefix.dirty ||
              refEnquiryNoPrefix.touched ||
              refEnquiryNoPrefix.untouched)
        }"
        [(ngModel)]="EnquiryNoPrefix"
        placeholder="Enter Enquiry No Prefix"
        name="EnquiryNoPrefix"
        id="EnquiryNoPrefix"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Upload File Size (KB)</span>
      <input
        required
        type="text"
        #refUploadMaxSize_In_KB="ngModel"
        numbersOnly
        [ngClass]="{
          'is-invalid': f.submitted && refUploadMaxSize_In_KB.invalid,
          'alert-warning':
            refUploadMaxSize_In_KB.invalid &&
            (refUploadMaxSize_In_KB.dirty ||
              refUploadMaxSize_In_KB.touched ||
              refUploadMaxSize_In_KB.untouched)
        }"
        [(ngModel)]="UploadMaxSize_In_KB"
        placeholder="Upload File Size"
        name="UploadMaxSize_In_KB"
        id="UploadMaxSize_In_KB"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> NPA DPD Days</span>
      <input
        required
        type="text"
        #refNPA_DPD="ngModel"
        numbersOnly
        [ngClass]="{
          'is-invalid': f.submitted && refNPA_DPD.invalid,
          'alert-warning':
            refNPA_DPD.invalid &&
            (refNPA_DPD.dirty || refNPA_DPD.touched || refNPA_DPD.untouched)
        }"
        [(ngModel)]="NPA_DPD"
        placeholder="NPA DPD Days"
        name="NPA_DPD"
        id="NPA_DPD"
        class="form-control input-text-css"
      />
    </div>

    <div class="col-md-3 p-1">
      <span class="required-lable"> Limit Of Cash Receipt </span>
      <input
        required
        type="number"
        #refLimitOfCashReceipt="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refLimitOfCashReceipt.invalid,
          'alert-warning':
            refLimitOfCashReceipt.invalid &&
            (refLimitOfCashReceipt.dirty ||
              refLimitOfCashReceipt.touched ||
              refLimitOfCashReceipt.untouched)
        }"
        [(ngModel)]="LimitOfCashReceipt"
        placeholder="Limit Of Cash Receipt"
        name="LimitOfCashReceipt"
        id="LimitOfCashReceipt"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-1">
      <span class="required-lable"> Limit Of Cash Payment </span>
      <input
        required
        type="number"
        #refLimitOfCashPayment="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refLimitOfCashPayment.invalid,
          'alert-warning':
            refLimitOfCashPayment.invalid &&
            (refLimitOfCashPayment.dirty ||
              refLimitOfCashPayment.touched ||
              refLimitOfCashPayment.untouched)
        }"
        [(ngModel)]="LimitOfCashPayment"
        placeholder="Limit Of Cash Payment"
        name="LimitOfCashPayment"
        id="LimitOfCashPayment"
        class="form-control input-text-css"
      />
    </div>
    <div class="col-md-3 p-2">
      <div class="form-group mb-0 d-flex align-items-center h-100">
        <mat-checkbox
          name="MakerChecker_Allow_InReceiptEntry"
          [(ngModel)]="MakerChecker_Allow_InReceiptEntry"
          class="mb-0"
        ></mat-checkbox>
        <span class="ml-2">Allow Maker Checker in Receipt Entry</span>
      </div>
    </div>
    <div class="col-md-2 p-1" style="text-align: center">
      <button
        (click)="Add_Current_FinancialYear()"
        class="btn font-size-12 button-btn"
      >
        Add Current Financial Year
      </button>
    </div>
    <div class="col-md-2 p-1" style="text-align: center">
      <button
        (click)="Add_CRC_Agency_Config()"
        class="btn font-size-12 button-btn"
      >
        Add CRC Agency Configuration
      </button>
    </div>
  </div>

  <div class="row m-0 formborder align-items-center">
    <!-- Days In Year -->
    <div class="col-md-2 p-2">
      <div class="form-group mb-0">
        <label class="required-lable">Days In Year</label>
        <select
        name="DaysInYear"
        required
        id="DaysInYear"
        [(ngModel)]="DaysInYear"
        class="form-control input-text-css"
        #refDaysInYear="ngModel"
        [ngClass]="{
          'is-invalid': f.submitted && refDaysInYear.invalid,
          'alert-warning':
            refDaysInYear.invalid &&
            (refDaysInYear.dirty ||
              refDaysInYear.touched ||
              refDaysInYear.untouched)
        }"
      >
        <option value= "">Select Days In Year</option>
        <option value="360">360</option> 
        <option value="365">365</option>
      </select>
      </div>
    </div>

    <!-- Data Freeze Date -->
    <div class="col-md-2 p-2">
      <div class="form-group mb-0">
        <label class="required-lable">Data Freeze Date</label>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="Data_Freeze"
            id="Data_Freeze"
            #refData_Freeze="ngModel"
            class="form-control input-text-css"
            [ngClass]="{
              'is-invalid': f.submitted && refData_Freeze.invalid,
              'alert-warning':
                refData_Freeze.invalid &&
                (refData_Freeze.dirty ||
                  refData_Freeze.touched ||
                  refData_Freeze.untouched)
            }"
            [(ngModel)]="Data_Freeze"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
    </div>

    <!-- Loan No. Generation -->
    <div class="col-md-3 p-2">
      <div class="form-group mb-0">
        <label class="d-block mb-1">Loan No. Generation</label>
        <div class="d-flex align-items-center">
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="LoanMannual"
              name="LoanSeries"
              #refLoanSeries="ngModel"
              [ngClass]="{
                'is-invalid': f.submitted && refLoanSeries.invalid,
                'alert-warning':
                  refLoanSeries.invalid &&
                  (refLoanSeries.dirty ||
                    refLoanSeries.touched ||
                    refLoanSeries.untouched)
              }"
              [(ngModel)]="LoanSeries"
              required
              value="Mannual"
            />
            <label class="form-check-label ml-1" for="LoanMannual"
              >Manual</label
            >
          </div>
          <div class="form-check form-check-inline ml-3">
            <input
              type="radio"
              class="form-check-input"
              id="LoanAutomatic"
              name="LoanSeries"
              #refLoanSeries="ngModel"
              [ngClass]="{
                'is-invalid': f.submitted && refLoanSeries.invalid,
                'alert-warning':
                  refLoanSeries.invalid &&
                  (refLoanSeries.dirty ||
                    refLoanSeries.touched ||
                    refLoanSeries.untouched)
              }"
              [(ngModel)]="LoanSeries"
              required
              value="Automatic"
            />
            <label class="form-check-label ml-1" for="LoanAutomatic"
              >Automatic</label
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Partner Code Generation -->
    <!-- <div class="col-md-3 p-2">
      <div class="form-group mb-0">
        <label class="d-block mb-1">Partner Code Generation</label>
        <div class="d-flex align-items-center">
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="PartnerMannual"
              name="IsPartnerCodeAuto"
              #refIsPartnerCodeAuto="ngModel"
              [ngClass]="{
                'is-invalid': f.submitted && refIsPartnerCodeAuto.invalid,
                'alert-warning':
                  refIsPartnerCodeAuto.invalid &&
                  (refIsPartnerCodeAuto.dirty ||
                    refIsPartnerCodeAuto.touched ||
                    refIsPartnerCodeAuto.untouched)
              }"
              [(ngModel)]="IsPartnerCodeAuto"
              required
              [value]="0"
            />
            <label class="form-check-label ml-1" for="PartnerMannual"
              >Manual</label
            >
          </div>
          <div class="form-check form-check-inline ml-3">
            <input
              type="radio"
              class="form-check-input"
              id="PartnerAutomatic"
              name="IsPartnerCodeAuto"
              #refIsPartnerCodeAuto="ngModel"
              [ngClass]="{
                'is-invalid': f.submitted && refIsPartnerCodeAuto.invalid,
                'alert-warning':
                  refIsPartnerCodeAuto.invalid &&
                  (refIsPartnerCodeAuto.dirty ||
                    refIsPartnerCodeAuto.touched ||
                    refIsPartnerCodeAuto.untouched)
              }"
              [(ngModel)]="IsPartnerCodeAuto"
              required
              [value]="1"
            />
            <label class="form-check-label ml-1" for="PartnerAutomatic"
              >Automatic</label
            >
          </div>
        </div>
      </div>
    </div> -->

    <!-- Second Row -->
    <div class="col-md-2 p-2">
      <div class="form-group mb-0 d-flex align-items-center h-100">
        <mat-checkbox
          name="Is_NOC_Block"
          [(ngModel)]="Is_NOC_Block"
          class="mb-0"
        ></mat-checkbox>
        <span class="ml-2">NOC Block</span>
      </div>
    </div>

    <div class="col-md-2 p-2" hidden>
      <div class="form-group mb-0 d-flex align-items-center h-100">
        <mat-checkbox
          name="IsMasking"
          [(ngModel)]="IsMasking"
          class="mb-0"
        ></mat-checkbox>
        <span class="ml-2">Masking Allow</span>
      </div>
    </div>

    <!-- Company Logo Upload -->
    <div class="col-md-4 p-2">
      <div class="form-group mb-0">
        <label class="required-lable">Company Logo</label>
        <div class="d-flex align-items-center">
          <input
            type="file"
            name="CompanyLogo"
            id="CompanyLogo"
            [(ngModel)]="CompanyLogo"
            accept=".jpg, .jpeg, .png"
            (change)="handleUpload($event)"
            class="form-control-file"
          />
        </div>
      </div>
    </div>

    <!-- Logo Preview -->
    <div class="col-md-4 p-2">
      <div class="form-group mb-0">
        <div class="d-flex align-items-center h-100">
          <img
            src="{{ UploadImageBase64 }}"
            alt="Logo Preview"
            class="img-thumbnail"
            style="width: 300px; height: 200px; object-fit: contain"
          />
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="col-md-12 p-2 text-center mt-2">
      <button
        type="submit"
        [disabled]="!f.form.valid"
        (click)="onSaveData()"
        class="btn font-size-12 button-btn px-4"
      >
        Update
      </button>
    </div>
  </div>
</form>

<div
  class="modal fade in"
  id="addCRCconfig"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Add CRC Agency Configuration
        </h6>

        <button
          type="button"
          (click)="oncloseaddCRCconfigModal()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body" style="font-size: 10px">
        <form #df="ngForm" novalidate *ngIf="isEdit == true">
          <div class="row m-0 formborder">
            <div class="col-md-4 p-1">
              <span class="required-lable"> CRC Agency </span>
              <select
                name="CRC_Agency"
                id="CRC_Agency"
                #refCRC_Agency="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refCRC_Agency.invalid,
                  'alert-warning':
                    refCRC_Agency.invalid &&
                    (refCRC_Agency.dirty ||
                      refCRC_Agency.touched ||
                      refCRC_Agency.untouched)
                }"
                [(ngModel)]="Bureau_Id"
                [disabled]="isEdit && isCRCAgencyDisabled"
                class="form-control input-text-css"
                required
              >
                <option value="">Select Agency</option>
                <option
                  *ngFor="let Type of filteredCRCAgencyBind"
                  [value]="Type.Id"
                >
                  {{ Type.Value }}
                </option>
              </select>
            </div>
            <div class="col-md-3 p-1">
              <span class="required-lable"> New Code </span>
              <input
                name="NewCode"
                [(ngModel)]="New_MemberCode"
                id="NewCode"
                placeholder="New Code"
                class="form-control input-text-css"
                required
                #refNewCode="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refNewCode.invalid,
                  'alert-warning':
                    refNewCode.invalid &&
                    (refNewCode.dirty ||
                      refNewCode.touched ||
                      refNewCode.untouched)
                }"
              />
            </div>
            <div class="col-md-3 p-1">
              <span class="required-lable"> New Short Name </span>
              <input
                name="NewShortName"
                [(ngModel)]="New_ShortName"
                id="NewShortName"
                placeholder="New Short Name"
                class="form-control input-text-css"
                required
                #refNewShortName="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refNewShortName.invalid,
                  'alert-warning':
                    refNewShortName.invalid &&
                    (refNewShortName.dirty ||
                      refNewShortName.touched ||
                      refNewShortName.untouched)
                }"
              />
            </div>
            <div class="col-md-3 p-1">
              <span> Old Code </span>
              <input
                name="OldCode"
                [(ngModel)]="Old_MemberCode"
                id="OldCode"
                placeholder="Old Code"
                class="form-control input-text-css"
                #refOldCode="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refOldCode.invalid,
                  'alert-warning':
                    refOldCode.invalid &&
                    (refOldCode.dirty ||
                      refOldCode.touched ||
                      refOldCode.untouched)
                }"
              />
            </div>
            <div class="col-md-3 p-1">
              <span> Old Short Name </span>
              <input
                name="OldShortName"
                [(ngModel)]="Old_ShortName"
                id="OldShortName"
                placeholder="Old Short Name"
                class="form-control input-text-css"
                #refOldShortName="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refOldShortName.invalid,
                  'alert-warning':
                    refOldShortName.invalid &&
                    (refOldShortName.dirty ||
                      refOldShortName.touched ||
                      refOldShortName.untouched)
                }"
              />
            </div>
            <div class="col-md-4 p-1">
              <span class="required-lable"> ROI Method</span>
              <select
                name="ROI_Method"
                id="ROI_Method"
                #refROI_Method="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refROI_Method.invalid,
                  'alert-warning':
                    refROI_Method.invalid &&
                    (refROI_Method.dirty ||
                      refROI_Method.touched ||
                      refROI_Method.untouched)
                }"
                [(ngModel)]="ROI_Method"
                class="form-control input-text-css"
                required
              >
                <option value="">Select ROI Method</option>
                <option *ngFor="let Type of ROI_Method_Bind" [value]="Type.Id">
                  {{ Type.Value }}
                </option>
              </select>
            </div>
            <div class="col-md-4 p-1">
              <span class="required-lable"> Calculation Method </span>
              <select
                name="Calculation_Method"
                id="Calculation_Method"
                #refCalculation_Method="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refCalculation_Method.invalid,
                  'alert-warning':
                    refCalculation_Method.invalid &&
                    (refCalculation_Method.dirty ||
                      refCalculation_Method.touched ||
                      refCalculation_Method.untouched)
                }"
                [(ngModel)]="Calculation_Method"
                class="form-control input-text-css"
                required
              >
                <option value="">Select Calculation Method</option>
                <option *ngFor="let Type of ROI_Cal_Bind" [value]="Type.Id">
                  {{ Type.Value }}
                </option>
              </select>
            </div>
            <div>
              <div class="col-md-12 mt-3" style="text-align: center">
                <button
                  type="submit"
                  *ngIf="isEdit == false"
                  [disabled]="!df.form.valid"
                  (click)="onSaveCRC_Agency_Config()"
                  class="btn font-size-12 button-btn"
                >
                  Save
                </button>
                <button
                  type="submit"
                  *ngIf="isEdit == true"
                  [disabled]="!df.form.valid"
                  (click)="onSaveCRC_Agency_Config()"
                  class="btn font-size-12 button-btn"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </form>

        <div class="table-responsive" *ngIf="isEdit == false">
          <mat-table
            [dataSource]="DataSource"
            matSort
            matTableExporter
            style="height: 200px; max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="#">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                style="max-width: 10px"
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell mw10"
              >
                {{ pageIndex * pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="BureauName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >BureauName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.BureauName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ROI_Method">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >ROI Method</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ROI_Method }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Calculation_Method">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                style="max-width: 150px"
                *matHeaderCellDef
                >Calculation Method
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                class="grid-cell"
                style="max-width: 150px"
              >
                <div>
                  {{ row.Calculation_Method }}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="New_ShortName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >New ShortName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.New_ShortName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Old_ShortName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Old ShortName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Old_ShortName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="New_MemberCode">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >New MemberCode</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.New_MemberCode }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Old_MemberCode">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Old MemberCode</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Old_MemberCode }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Actions">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                style="max-width: 50px"
                *matHeaderCellDef
                >Edit</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row"
                class="grid-cell mw50"
                style="max-width: 50px"
              >
                <i
                  class="fa fa-edit mr-1"
                  style="font-size: medium; cursor: pointer"
                  title="Edit"
                  (click)="EDIT_CRC_Agency_Config(row)"
                ></i>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          <div class="row m-0 align-items-center" style="background: #fff">
            <div class="col-md-4 p-1 pb-2 pt-2">
              <button
                class="btn font-size-12 button-btn"
                (click)="EDIT_CRC_Agency_Config_Add()"
                *ngIf="canShowAddButton()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Add
              </button>
            </div>
            <div class="col-md-8"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
